import { ParametersPageAction, ParametersPageActionKeys } from './actions';
import Utils from '../../utils';

export interface ParametersPageState {
	usedSpace: string;
	freeSpace: string;
}

const initialState: ParametersPageState = {
	usedSpace: '--',
	freeSpace: '--'
};

export function parametersPage(state: ParametersPageState = initialState, action: ParametersPageAction): ParametersPageState {
	let newState = Utils.deepCopy(state);

	switch (action.type) {
		case ParametersPageActionKeys.SET_USED_SPACE:
			newState.usedSpace = action.value;
			break;
		case ParametersPageActionKeys.SET_FREE_SPACE:
			newState.freeSpace = action.value;
			break;
		default:
			return state;
	}
	return newState;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/reducer.ts